;(function () {
  'use strict'

  angular.module('contrast.ui.dev').controller('UiDevIconsCtrl', UiDevIconsCtrl)

  function UiDevIconsCtrl(csIconConfig) {
    'ngInject'

    var vm = this

    function init() {
      vm.icons = []
      Object.keys(csIconConfig).forEach(function (t) {
        vm.icons.push({
          id: t,
          classes: csIconConfig[t]
        })
      })
    }

    init()
  }
})()
